/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateAlertTemplateResponse {
    getFixupPrototypeFunction() { return CreateAlertTemplateResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateAlertTemplateResponse>): CreateAlertTemplateResponse {
        let obj = Object.assign(new CreateAlertTemplateResponse(), model);
        CreateAlertTemplateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateAlertTemplateResponse>): CreateAlertTemplateResponse {
        if (!model) return null;
        return CreateAlertTemplateResponse.newInstance(<CreateAlertTemplateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateAlertTemplateResponse) {
        if (!obj) return;

        models.CreateAlertTemplateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateAlertTemplateResponse): boolean {
        Object.setPrototypeOf(obj, CreateAlertTemplateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Create template response
     */
    message: string;

    /**
     * Create Monitoring Template Details
     */
    data: any;

}
